import { EmploymentPeriodStatusEnum, EmploymentPeriodViewModel } from '@fora-monorepo/employer-my-pages-common/types';

/**
 *
 * @param employmentPeriods
 * @returns Active employment period if any is active,
 * otherwise the closest future employment period if there is any,
 * otherwise the closest expired employment period if there is any,
 * otherwise null
 */
export const getCurrentEmploymentPeriod = (
  employmentPeriods: EmploymentPeriodViewModel[]
): EmploymentPeriodViewModel | null => {
  // Return active employment period if one exists
  const activeEmploymentPeriods = employmentPeriods.filter(
    employmentPeriod => employmentPeriod.employmentStatus === EmploymentPeriodStatusEnum.Active
  );
  if (activeEmploymentPeriods.length > 0) {
    // Sort so that the earliest employment period is put first
    // (in manual pay reporting there can be multiple active periods,
    // in that case we are interested in the earliest one so that
    // the available attri pay months are calculated using that period)
    activeEmploymentPeriods.sort((a, b) => a.employmentStartDate.localeCompare(b.employmentStartDate));
    return activeEmploymentPeriods[0];
  }

  // Return earliest future employment period if any exists
  const futureEmploymentPeriods = employmentPeriods.filter(
    employmentPeriod => employmentPeriod.employmentStatus === EmploymentPeriodStatusEnum.Future
  );
  if (futureEmploymentPeriods.length > 0) {
    // Sort so that the earliest employment period is put first
    futureEmploymentPeriods.sort((a, b) => a.employmentStartDate.localeCompare(b.employmentStartDate));

    return futureEmploymentPeriods[0];
  }

  // Return latest expired employment period if any exists
  const expiredEmploymentPeriods = employmentPeriods.filter(
    employmentPeriod => employmentPeriod.employmentStatus === EmploymentPeriodStatusEnum.Expired
  );
  if (expiredEmploymentPeriods.length > 0) {
    // Sort so that the latest employment period is put first
    expiredEmploymentPeriods.sort((a, b) => (b.employmentEndDate ?? '').localeCompare(a.employmentEndDate ?? ''));

    return expiredEmploymentPeriods[0];
  }

  return null;
};
